export default __webpack_public_path__ + "static/media/leftWhite.e91ef6e4.svg";